export default __webpack_public_path__ + "static/media/9.a4e7eae7.jpeg";